import { IsOptional, ValidateIf, ValidateNested } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { v4 as uuid } from 'uuid';
import {
  advancedFormGroup,
} from '@magieno/common';
import { type } from '@pristine-ts/data-mapping-common';
import { CalculationDate } from '../../../../../models/calculation.date';
import {
  IncomeTaxPersonalChildFederalInRrspOptions,
} from './income-tax-personal-child-federal-in-rrsp.options';
import {
  IncomeTaxPersonalChildQuebecInRrspOptions,
} from './income-tax-personal-child-quebec-in-rrsp.options';
import { IncomeTaxPersonalChildOptions } from '../../../income-tax/personal/personal/income-tax-personal-child.options';
import {
  IncomeTaxPersonalChildCampOptions,
} from '../../../income-tax/personal/common/income-tax-personal-child-camp.options';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  IncomeTaxPersonalChildCommonOptions,
} from '../../../income-tax/personal/common/income-tax-personal-child-common.options';

@translationBaseKey('income-tax-child-in-rrsp-options')
export class IncomeTaxPersonalChildInRrspOptions implements Omit<IncomeTaxPersonalChildOptions,
  'federal' |
  'quebec'
> {
  @type(() => new IncomeTaxPersonalChildFederalInRrspOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildFederalInRrspOptions,
  })
  @ValidateNested()
  @IsOptional()
  // todo: we know currentPath's last part will be this class. Remove our part and get our parent from the path.
  @ValidateIf((object: any, root: any, currentPath: string): boolean => {

    /*
    The code below is a replacement for this since we don't know for sure if the instanceof will work.
    if(root instanceof IncomeTaxPersonalOptions) {
      return root.isCareExpensesCalculated;
    } else if(root instanceof SalaryDividendOptions) {
      return root.incomeTaxPersonalOptions.isCareExpensesCalculated;
    }
     */

    if (root.hasOwnProperty('isCareExpensesCalculated')) {
      return root['isCareExpensesCalculated'];
    } else if (root.hasOwnProperty('personalIncomeTaxOptions') && root['personalIncomeTaxOptions'].hasOwnProperty('isCareExpensesCalculated')) {
      return root['personalIncomeTaxOptions']['isCareExpensesCalculated'];
    }

    return false;
  })
  federal?: IncomeTaxPersonalChildFederalInRrspOptions;

  @type(() => new IncomeTaxPersonalChildQuebecInRrspOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalChildQuebecInRrspOptions,
  })
  @ValidateNested()
  @IsOptional()
  @ValidateIf((object: any, root: any, currentPath: string): boolean => {

    /*
    The code below is a replacement for this since we don't know for sure if the instanceof will work.
    if(root instanceof IncomeTaxPersonalOptions) {
      return root.isCareExpensesCalculated;
    } else if(root instanceof SalaryDividendOptions) {
      return root.incomeTaxPersonalOptions.isCareExpensesCalculated;
    }
     */

    if (root.hasOwnProperty('isCareExpensesCalculated')) {
      return root['isCareExpensesCalculated'];
    } else if (root.hasOwnProperty('personalIncomeTaxOptions') && root['personalIncomeTaxOptions'].hasOwnProperty('isCareExpensesCalculated')) {
      return root['personalIncomeTaxOptions']['isCareExpensesCalculated'];
    }

    return false;
  })
  quebec?: IncomeTaxPersonalChildQuebecInRrspOptions;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'id')
  id: string = uuid();

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'firstName')
  firstName: string;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'lastName')
  lastName: string;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'camps')
  camps: IncomeTaxPersonalChildCampOptions[] = [];

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'birthdate')
  birthdate: CalculationDate;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'isDisabled')
  isDisabled: boolean;

  @clonePropertyMetadata<IncomeTaxPersonalChildCommonOptions>(IncomeTaxPersonalChildCommonOptions, 'netIncome')
  netIncome: number;
}
